import { Stack, Typography } from "@mui/material";

type Props = {
  text: string;
  value: string;
};

export const ProgressBarTooltip = ({ text, value }: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap="14px"
    >
      <Typography variant="body2" align="center" color="white" fontWeight={500}>
        {text}
      </Typography>
      <Typography variant="body2" align="center" color="white" fontWeight={500}>
        {value}
      </Typography>
    </Stack>
  );
};
